import { SourceApp } from '../components/sidebar/sidebar.component';

export interface SidebarConfig {
  backgroundColor: string;
  logoPath: string;
}

export function getSidebarConfig(source: SourceApp): SidebarConfig {
  switch (source) {
    case SourceApp.TEACHER:
      return {
        backgroundColor: '#000000',
        logoPath: 'assets/img/logo/isophi-diag_wheel_logo_256.png',
      };
    case SourceApp.PAP:
      return {
        backgroundColor: '#000000',
        logoPath: 'assets/img/logo/isophi-pap_wheel_logo_256.png',
      };
    case SourceApp.PARENT:
      return {
        backgroundColor: '#000000',
        logoPath: 'assets/img/logo/isophi-parent_wheel_logo_256.png',
      };
    case SourceApp.MANAGEMENT:
      return {
        backgroundColor: '#FADAE3',
        logoPath: 'assets/img/logo/isophi-management-logo-grey.png',
      };
    default:
      throw new Error(`Unsupported source app: ${source}`);
  }
}
